import React, { PureComponent, ReactNode } from "react";
import { Animated } from "react-animated-css";
import { Redirect } from "react-router-dom";
import Navbar from "../../components/CustomNav/CustomNav.Component";

import {
  Container,
  MenuGrid,
  MenuGridItem,
} from "../Teachers/TeacherMenu.styles";
import profileImg from "../../assets/images/mainmenus/profile.png";
import helpImg from "../../assets/images/mainmenus/help.png";
import skillsImg from "../../assets/images/mainmenus/skills.png";
import pathways from "../../assets/images/mainmenus/pathways.png";
import { currentUser, isUserLoggedIn } from "src/common/services";

interface Props {
  history: any;
}
interface State {
  path: string;
  toLogin: boolean;
}

const menuItems = [
  {
    title: "My Pathways",
    description: "Access all of your learning pathways here.",
    color: "#ff0b0b",
    bg: pathways,
    to: "/students/home",
  },

  {
    title: "My Performance",
    description: "Keep up to date on all of your progress.",
    color: "#acff24",
    bg: skillsImg,
    to: "/students/datacentre",
  },

  {
    title: "My Profile",
    description: "Keep everything about you up to date here.",
    color: "#3ee9f7",
    bg: profileImg,
    to: "/students/profilepage",
  },

  {
    title: "Help",
    description:
      "A list of articles and videos to help your Performance Learning journey.",
    color: "#9143fc",
    bg: helpImg,
    to: "helpcenter",
  },
];

class StudentsMenu extends PureComponent<Props, State> {
  constructor(props: Props) {
    super(props);

    this.state = {
      path: "",
      toLogin: false,
    };
  }

  public componentDidMount() {
    if (!isUserLoggedIn()) {
      this.setState({ toLogin: true });
      return;
    }
  }

  public onLogout = (arg) => {
    this.setState({ toLogin: true });
  };

  public onMenuItemClick = (path) => {
    if (path === "helpcenter") {
      window.open(
        "https://myperformancelearning.com/category/revision/",
        "_blank"
      );
      return;
    }
    this.props.history.push(path);
  };

  public render(): ReactNode {
    if (this.state.toLogin) {
      return <Redirect to="/login" />;
    }

    return (
      <Container>
        <Navbar logoutParent={this.onLogout} />
        <h1 className="menu-heading">
          Hey <span>{currentUser()}</span>
        </h1>
        <MenuGrid maxWidth="1000px">
          {menuItems.map((item, i) => (
            <Animated
              animationIn="fadeIn"
              animationOut="fadeOut"
              isVisible={true}
              animationInDuration={2000}
              key={`school_menu_item_${i}`}
            >
              <MenuGridItem
                highlightColor={item.color}
                backgroundImage={item.bg}
              >
                <div className="bg-holder" />

                <div className="menu-item-content">
                  <div>
                    <h2 className="menu-item-name">{item.title}</h2>
                    <p className="menu-item-description">{item.description}</p>
                  </div>
                  <button
                    onClick={this.onMenuItemClick.bind(this, item.to)}
                    className="menu-item-btn"
                  >
                    EXPLORE
                  </button>
                </div>
              </MenuGridItem>
            </Animated>
          ))}
        </MenuGrid>
      </Container>
    );
  }
}

export default StudentsMenu;



// WEBPACK FOOTER //
// ./src/pages/Students/StudentMenu.Component.tsx